/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ExternalIcon } from '@cgn/framework-ui-components/icons';
import { loadContenutiSimiliAQuesito } from '../../Api/ricerca';

const ListaContenutiSimili = ({
  ufficioSelezionato, titolo, messaggio, codiceArea, minScore, numeroRisultati, nessunSuggerimentoComponent,
}) => {
  const [suggerimenti, setSuggerimenti] = useState();

  useEffect(() => {
    if (codiceArea && titolo && messaggio && titolo.length > 3 && messaggio.length > 3) {
      loadContenutiSimiliAQuesito(ufficioSelezionato, titolo, messaggio, codiceArea, numeroRisultati)
        .then((items) => items.filter((item) => item.Score >= minScore))
        .then((items) => {
          setSuggerimenti(
            items.map((item) => ({
              label: item.Titolo,
              href: (item.DossierContenuto != null && item.DossierContenuto.length > 0)
                // eslint-disable-next-line max-len
                ? `${window.UrlAssistente}/#/Area/${item.IdArea}/Dossier/${item.DossierContenuto[0].IdDossier}/Contenuto/${item.IdContenuto}?source=contenutiSimili`
                : `${window.UrlAssistente}/#/Area/${item.IdArea}/Contenuto/${item.IdContenuto}?source=contenutiSimili`,
            })),
          );
        })
        .catch(() => { setSuggerimenti(null); });
    } else {
      setSuggerimenti(undefined);
    }
  }, [titolo, messaggio, codiceArea, minScore, numeroRisultati, ufficioSelezionato]);

  if (!suggerimenti || suggerimenti.length === 0) return nessunSuggerimentoComponent;

  return (
    <div className="lista-contentuti">
      <span>Alcune possibili soluzioni al tuo problema:</span>
      {suggerimenti.map((suggerimento) => (
        <div key={suggerimento.label} className="lista-contentuti__elemento">
          <ExternalIcon />
          <a href={suggerimento.href} target="_blank" dangerouslySetInnerHTML={{ __html: suggerimento.label }} rel="noreferrer" />
        </div>
      ))}
    </div>
  );
};

ListaContenutiSimili.propTypes = {
  ufficioSelezionato: PropTypes.string,
  titolo: PropTypes.string,
  messaggio: PropTypes.string,
  codiceArea: PropTypes.string,
  numeroRisultati: PropTypes.number,
  minScore: PropTypes.number,
  nessunSuggerimentoComponent: PropTypes.element,
};

ListaContenutiSimili.defaultProps = {
  ufficioSelezionato: undefined,
  titolo: undefined,
  messaggio: undefined,
  codiceArea: undefined,
  numeroRisultati: 5,
  minScore: 0.011,
  nessunSuggerimentoComponent: undefined,
};

export default ListaContenutiSimili;
